import styled from "styled-components";
import { breakpoint, color, font } from "Style/Globals";

export const AdminImportStyle = {
    Container: styled.section`
        padding-top: 25px;
    `,
    Intro: styled.p`
        line-height: 1.5;
        max-width: 900px;
        margin-bottom: 20px;
    `,
    CardGrid: styled.div`
        display: grid;
        gap: 20px;

        @media ${breakpoint.min1050} {
            grid-template-columns: 1fr 1fr;
        }
    `,
    Card: styled.div`
        background-color: ${color.lightmodeBgContent};
        border: 1px solid ${color.lightgrey2};
        padding: 20px;

        @media (prefers-color-scheme: dark) {
            background-color: ${color.darkmodeBgContent};
            border-color: ${color.darkmodeBgBody};
        }
    `,
    CardTitle: styled.h3`
        font-family: ${font.bold};
        font-size: 20px;
        margin-bottom: 6px;
    `,
    CardText: styled.p`
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 15px;
    `,
    UploadRow: styled.div`
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 10px;
    `,
    HiddenFileInput: styled.input`
        display: none;
    `,
    FileName: styled.span`
        font-size: 13px;
        color: ${color.black};

        @media (prefers-color-scheme: dark) {
            color: ${color.white};
        }
    `,
    Message: styled.p<{ isError?: boolean }>`
        min-height: 22px;
        font-size: 13px;
        margin-bottom: 8px;
        color: ${props => props.isError ? color.red : color.green};
    `,
    ControlsRow: styled.div`
        margin-bottom: 10px;
    `,
    CheckboxLabel: styled.label`
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        cursor: pointer;
    `,
    CheckboxInput: styled.input`
        margin: 0;
    `,
    MemoryHint: styled.p`
        font-size: 13px;
        margin-bottom: 12px;
    `,
    TableWrap: styled.div`
        overflow-x: auto;
    `,
    Table: styled.table`
        width: 100%;
        border-collapse: collapse;
    `,
    TableHeadCell: styled.th`
        text-align: left;
        padding: 8px;
        border-bottom: 2px solid ${color.lightgrey2};
        font-family: ${font.bold};
        font-size: 13px;
        text-transform: uppercase;

        @media (prefers-color-scheme: dark) {
            border-bottom-color: ${color.darkmodeBgBody};
        }
    `,
    TableCell: styled.td`
        padding: 8px;
        border-bottom: 1px solid ${color.lightgrey2};
        font-size: 14px;

        @media (prefers-color-scheme: dark) {
            border-bottom-color: ${color.darkmodeBgBody};
        }
    `,
    ValidityCell: styled.td<{ isValid: boolean }>`
        padding: 8px;
        border-bottom: 1px solid ${color.lightgrey2};
        color: ${props => props.isValid ? color.green : color.red};

        @media (prefers-color-scheme: dark) {
            border-bottom-color: ${color.darkmodeBgBody};
        }
    `,
    RequestStatusCell: styled.td<{ status: "idle" | "success" | "error" }>`
        padding: 8px;
        border-bottom: 1px solid ${color.lightgrey2};
        color: ${props => {
            if (props.status === "success") return color.green;
            if (props.status === "error") return color.red;
            return color.palegraydark;
        }};

        @media (prefers-color-scheme: dark) {
            border-bottom-color: ${color.darkmodeBgBody};
        }
    `,
    ValidityIconWrap: styled.span`
        display: inline-flex;
        align-items: center;
    `,
    EmptyState: styled.p`
        font-size: 14px;
        color: ${color.palegraydark};
        margin-top: 8px;
    `,
};
